import { App } from 'application/components/App';
import { Login } from 'application/components/Login/Login';
import { PaymentErrorPage } from 'application/components/Payment/PaymentErrorPage/PaymentErrorPage';
import { PaymentSuccessPage } from 'application/components/Payment/PaymentSuccessPage/PaymentSuccessPage';
import { Register } from 'application/components/Register/Register';
import { ResetPassword } from 'application/components/ResetPassword/ResetPassword';
import { WelcomePage } from 'application/components/WelcomePage/WelcomePage';
import { BranchList } from 'branch/components/List/BranchList';
import { commonRoutes } from 'common/contact/common/helper/CommonRoute';
import { ProjectRouteNames } from 'common/helper/ProjectRouteNames';
import { branchRoutes } from 'common/helper/SahinYazilimRoute';
import { createRoute } from 'common/helper/createRoute';
import { Navigate } from 'react-router-dom';

export const mainRoutes = createRoute([
  {
    path: ProjectRouteNames.ADMIN,
    element: <BranchList />,
  },
  {
    path: `${ProjectRouteNames.ADMIN}/:branchId/*`,
    element: <App />,
  },
  {
    path: ProjectRouteNames.PAYMENT_ERROR,
    element: <PaymentErrorPage />,
  },
  {
    path: ProjectRouteNames.PAYMENT_SUCCESS,
    element: <PaymentSuccessPage />,
  },
  {
    path: ProjectRouteNames.ALL,
    element: <Navigate to={`/${ProjectRouteNames.ADMIN}`} />,
  },
]);

export const welcomeRoute = createRoute([
  {
    path: ProjectRouteNames.ALL,
    element: <WelcomePage />,
  },
  {
    path: ProjectRouteNames.ALL,
    element: <Navigate to={ProjectRouteNames.LOGIN} />,
  },
]);

export const welcomeRoutes = createRoute([
  {
    path: ProjectRouteNames.LOGIN,
    element: <Login />,
  },
  {
    path: ProjectRouteNames.REGISTER,
    element: <Register />,
  },
  {
    path: ProjectRouteNames.RESET_PASSWORD,
    element: <ResetPassword />,
  },
  // {
  //   path: ProjectRouteNames.SUPPORT,
  //   element: <Support />,
  // },
  {
    path: ProjectRouteNames.ALL,
    element: <Navigate to={ProjectRouteNames.LOGIN} />,
  },
]);

export const homeRoutes = createRoute([
  {
    path: `/${ProjectRouteNames.COMMON}/*`,
    element: commonRoutes,
  },
  {
    path: ProjectRouteNames.ALL,
    element: branchRoutes,
  },
]);
